export const formDefaultValues = {
  name: '',
  cuit: '',
  note: '',
}
